// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdash-hero {
    display: grid;
    grid-template-columns: 1fr minmax(220px, 280px);
    gap: 20px;
    margin-bottom: 16px;
    padding: 22px;
    border-radius: 12px;
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 55%, #0e7490 100%);
    color: #f8fafc;
}

.mdash-name {
    font-size: 1.65rem;
    font-weight: 700;
    margin: 0 0 6px;
}

.mdash-meta {
    margin: 0 0 4px;
    color: #cbd5e1;
    font-size: 0.95rem;
}

.mdash-cohort {
    margin: 12px 0 0;
}

.mdash-pill {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    font-size: 0.85rem;
}

.mdash-mentor-card {
    background: rgba(15, 23, 42, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    padding: 14px 16px;
}

.mdash-mentor-label {
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 0.72rem;
    margin: 0 0 10px;
    color: #94a3b8;
}

.mdash-mentor-row {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 12px;
}

.mdash-mentor-initials,
.mdash-mentor-photo {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    flex-shrink: 0;
}

.mdash-mentor-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #38bdf8;
    color: #0f172a;
    font-weight: 700;
    font-size: 0.85rem;
}

.mdash-mentor-photo {
    object-fit: cover;
}

.mdash-mentor-name {
    font-size: 1.05rem;
    margin: 0 0 2px;
    font-weight: 650;
}

.mdash-mentor-role,
.mdash-mentor-unassigned {
    margin: 0;
    color: #cbd5e1;
    font-size: 0.9rem;
}

.mdash-mentor-cta {
    width: 100%;
}

.mdash-strip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 18px;
    margin-bottom: 16px;
    border: 1px solid #bfdbfe;
    border-radius: 10px;
    background: #eff6ff;
}

.mdash-strip-title {
    margin: 0 0 4px;
    font-weight: 650;
    color: #0f172a;
}

.mdash-strip-preview {
    margin: 0;
    color: #475569;
    font-size: 0.9rem;
}

.mdash-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 16px;
    background: #fff;
}

.mdash-card-title {
    font-size: 1.1rem;
    font-weight: 650;
    margin: 0 0 4px;
    color: #0f172a;
}

.mdash-card-sub {
    margin: 0 0 14px;
    color: #64748b;
    font-size: 0.92rem;
}

.mdash-check-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.mdash-check-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 12px 0;
    border-top: 1px solid #e2e8f0;
}

.mdash-check-row:first-child {
    border-top: none;
    padding-top: 0;
}

.mdash-check-title {
    margin: 0 0 2px;
    font-weight: 600;
    color: #0f172a;
}

.mdash-check-state {
    margin: 0;
    font-size: 0.88rem;
    color: #64748b;
}

.mdash-done-pill {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 999px;
    background: #dcfce7;
    color: #166534;
    font-size: 0.85rem;
    font-weight: 600;
}

.mdash-empty {
    margin: 0 0 10px;
    color: #64748b;
}

.mdash-upcoming-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.mdash-upcoming-row {
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #f8fafc;
}

.mdash-upcoming-when {
    margin: 0 0 4px;
    font-weight: 700;
    color: #0f172a;
}

.mdash-upcoming-meta,
.mdash-upcoming-topic {
    margin: 0;
    color: #64748b;
    font-size: 0.88rem;
}

.mdash-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 16px;
}

.mdash-modal {
    width: min(520px, 100%);
    /* max-height: min(80vh, 640px); */
    overflow: auto;
    background: #fff;
    border-radius: 12px;
    padding: 18px 20px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);
}

.mdash-modal-head {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 4px 12px;
    margin-bottom: 12px;
    align-items: start;
}

.mdash-modal-title {
    margin: 0;
    font-size: 1.1rem;
    grid-column: 1;
}

.mdash-modal-sub {
    margin: 0;
    font-size: 0.8rem;
    color: #64748b;
    grid-column: 1;
}

.mdash-modal-head .btn {
    grid-row: 1 / span 2;
    grid-column: 2;
}

.mdash-thread {
    list-style: none;
    margin: 0 0 12px;
    padding: 0;
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
    min-height: 120px;
    max-height: 350px;
    overflow: auto;
}

.mdash-bubble {
    padding: 8px 12px;
    border-radius: 0px 4px 4px 4px;
    background: #f1f5f9;
    max-width: 90%;
    position: relative;
    align-self: flex-start;
}
.mdash-bubble:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-width: 3px;
    border-style: solid;
    border-color: #f1f5f9 #f1f5f9 transparent transparent;
    right: 100%;
    top: 0;
}

.mdash-bubble.is-me {
    align-self: flex-end;
    background: #dbeafe;
    border-radius: 4px 0px 4px 4px;
}
.mdash-bubble.is-me:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-width: 3px;
    border-style: solid;
    border-color: #dbeafe  transparent transparent #dbeafe ;
    right: auto;
    top: 0;
    left: 100%;
}
.mdash-bubble-role {
    display: block;
    font-size: 0.6rem;
    text-transform: uppercase;
    color: #64748b;
    margin-bottom: 2px;
}

.mdash-bubble-body {
    margin: 0;
    white-space: pre-wrap;
}

.mdash-thread-empty {
    color: #94a3b8;
    font-size: 0.9rem;
}

.mdash-compose {
    display: grid;
    gap: 8px;
}

@media (max-width: 720px) {
    .mdash-hero {
        grid-template-columns: 1fr;
    }

    .mdash-check-row {
        flex-direction: column;
        align-items: flex-start;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentee/menteeDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0EAA0E;IAC1E,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,qDAAqD;IACrD,WAAW;IACX,MAAM;AACV;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;IACvD,WAAW;IACX,MAAM;IACN,UAAU;AACd;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".mdash-hero {\n    display: grid;\n    grid-template-columns: 1fr minmax(220px, 280px);\n    gap: 20px;\n    margin-bottom: 16px;\n    padding: 22px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 55%, #0e7490 100%);\n    color: #f8fafc;\n}\n\n.mdash-name {\n    font-size: 1.65rem;\n    font-weight: 700;\n    margin: 0 0 6px;\n}\n\n.mdash-meta {\n    margin: 0 0 4px;\n    color: #cbd5e1;\n    font-size: 0.95rem;\n}\n\n.mdash-cohort {\n    margin: 12px 0 0;\n}\n\n.mdash-pill {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.12);\n    font-size: 0.85rem;\n}\n\n.mdash-mentor-card {\n    background: rgba(15, 23, 42, 0.35);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 10px;\n    padding: 14px 16px;\n}\n\n.mdash-mentor-label {\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    font-size: 0.72rem;\n    margin: 0 0 10px;\n    color: #94a3b8;\n}\n\n.mdash-mentor-row {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.mdash-mentor-initials,\n.mdash-mentor-photo {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.mdash-mentor-initials {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #38bdf8;\n    color: #0f172a;\n    font-weight: 700;\n    font-size: 0.85rem;\n}\n\n.mdash-mentor-photo {\n    object-fit: cover;\n}\n\n.mdash-mentor-name {\n    font-size: 1.05rem;\n    margin: 0 0 2px;\n    font-weight: 650;\n}\n\n.mdash-mentor-role,\n.mdash-mentor-unassigned {\n    margin: 0;\n    color: #cbd5e1;\n    font-size: 0.9rem;\n}\n\n.mdash-mentor-cta {\n    width: 100%;\n}\n\n.mdash-strip {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 14px 18px;\n    margin-bottom: 16px;\n    border: 1px solid #bfdbfe;\n    border-radius: 10px;\n    background: #eff6ff;\n}\n\n.mdash-strip-title {\n    margin: 0 0 4px;\n    font-weight: 650;\n    color: #0f172a;\n}\n\n.mdash-strip-preview {\n    margin: 0;\n    color: #475569;\n    font-size: 0.9rem;\n}\n\n.mdash-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 18px 20px;\n    margin-bottom: 16px;\n    background: #fff;\n}\n\n.mdash-card-title {\n    font-size: 1.1rem;\n    font-weight: 650;\n    margin: 0 0 4px;\n    color: #0f172a;\n}\n\n.mdash-card-sub {\n    margin: 0 0 14px;\n    color: #64748b;\n    font-size: 0.92rem;\n}\n\n.mdash-check-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.mdash-check-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    padding: 12px 0;\n    border-top: 1px solid #e2e8f0;\n}\n\n.mdash-check-row:first-child {\n    border-top: none;\n    padding-top: 0;\n}\n\n.mdash-check-title {\n    margin: 0 0 2px;\n    font-weight: 600;\n    color: #0f172a;\n}\n\n.mdash-check-state {\n    margin: 0;\n    font-size: 0.88rem;\n    color: #64748b;\n}\n\n.mdash-done-pill {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 999px;\n    background: #dcfce7;\n    color: #166534;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.mdash-empty {\n    margin: 0 0 10px;\n    color: #64748b;\n}\n\n.mdash-upcoming-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.mdash-upcoming-row {\n    padding: 10px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    background: #f8fafc;\n}\n\n.mdash-upcoming-when {\n    margin: 0 0 4px;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.mdash-upcoming-meta,\n.mdash-upcoming-topic {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.88rem;\n}\n\n.mdash-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1050;\n    padding: 16px;\n}\n\n.mdash-modal {\n    width: min(520px, 100%);\n    /* max-height: min(80vh, 640px); */\n    overflow: auto;\n    background: #fff;\n    border-radius: 12px;\n    padding: 18px 20px;\n    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);\n}\n\n.mdash-modal-head {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 4px 12px;\n    margin-bottom: 12px;\n    align-items: start;\n}\n\n.mdash-modal-title {\n    margin: 0;\n    font-size: 1.1rem;\n    grid-column: 1;\n}\n\n.mdash-modal-sub {\n    margin: 0;\n    font-size: 0.8rem;\n    color: #64748b;\n    grid-column: 1;\n}\n\n.mdash-modal-head .btn {\n    grid-row: 1 / span 2;\n    grid-column: 2;\n}\n\n.mdash-thread {\n    list-style: none;\n    margin: 0 0 12px;\n    padding: 0;\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 8px;\n    min-height: 120px;\n    max-height: 350px;\n    overflow: auto;\n}\n\n.mdash-bubble {\n    padding: 8px 12px;\n    border-radius: 0px 4px 4px 4px;\n    background: #f1f5f9;\n    max-width: 90%;\n    position: relative;\n    align-self: flex-start;\n}\n.mdash-bubble:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-width: 3px;\n    border-style: solid;\n    border-color: #f1f5f9 #f1f5f9 transparent transparent;\n    right: 100%;\n    top: 0;\n}\n\n.mdash-bubble.is-me {\n    align-self: flex-end;\n    background: #dbeafe;\n    border-radius: 4px 0px 4px 4px;\n}\n.mdash-bubble.is-me:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-width: 3px;\n    border-style: solid;\n    border-color: #dbeafe  transparent transparent #dbeafe ;\n    right: auto;\n    top: 0;\n    left: 100%;\n}\n.mdash-bubble-role {\n    display: block;\n    font-size: 0.6rem;\n    text-transform: uppercase;\n    color: #64748b;\n    margin-bottom: 2px;\n}\n\n.mdash-bubble-body {\n    margin: 0;\n    white-space: pre-wrap;\n}\n\n.mdash-thread-empty {\n    color: #94a3b8;\n    font-size: 0.9rem;\n}\n\n.mdash-compose {\n    display: grid;\n    gap: 8px;\n}\n\n@media (max-width: 720px) {\n    .mdash-hero {\n        grid-template-columns: 1fr;\n    }\n\n    .mdash-check-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
